module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted vertical footer segment",
    attrs: {
      "ssstyle": "z-index:-2;height:25vh;"
    }
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    attrs: {
      "ssstyle": "position:fixed; bottom:0;"
    }
  }, [_c('div', {
    staticClass: "ui inverted divided equal height stackable grid",
    staticStyle: {
      "padding": "5vh 0",
      "ssz-index": "-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Help")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.openHelpModal('first')
      }
    }
  }, [_vm._v("F.A.Q")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.openHelpModal('second')
      }
    }
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$parent.openHelpModal('third')
      }
    }
  }, [_vm._v("Feature Requests")])])]), _vm._v(" "), _c('div', {
    staticClass: "three wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Quick Links")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted link list"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/productsettings')
      }
    }
  }, [_vm._v("Product Tracking Settings")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/settings')
      }
    }
  }, [_vm._v("Email Settings")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/settings')
      }
    }
  }, [_vm._v("Account Settings")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://sentrykit.com/press-release",
      "target": "_blank"
    }
  }, [_vm._v("Press Release")])])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "three wide column"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../assets/skwhite_noslogan.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "seven wide column"
  }, [_c('h4', {
    staticClass: "ui inverted header"
  }, [_vm._v("Made with "), _c('i', {
    staticClass: "compact red heart icon",
    staticStyle: {
      "margin": "-6px 1px"
    }
  }), _vm._v(" by entrepreneurs for entrepreneurs.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "grey"
    }
  }, [_c('span', {}, [_vm._v("We use cookies for login and minor things.")]), _vm._v(" "), _c('span', {}, [_vm._v("We don't share, sell or rent your data.")]), _vm._v(" "), _c('span', {}, [_vm._v("Your data sleeps and travels encrypted.")]), _vm._v(" "), _c('span', {}, [_vm._v("We don't sell on Amazon.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-386adb2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 750
// module chunks = 2